



































































































































































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import SupplierJson from "@/doc/Supplier.json";
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import { setCommon, errorMsg } from "@/utils/request";
import { getSaveQuestionDisplayCheckRequest } from "@/request/questionConfiguration";
@Component({
  name: "system",
})
export default class CombinationProperty extends Vue {
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Prop() questionOptions: any; // 问题类型options
  @Prop() result: any;
  @Prop() title: any;
  @Prop() applist: any;
  @Provide() private parameterData: any = [
    { id: 201, name: "全部" },
    { id: 100, name: "PV" },
    // { id: 107, name: "CPV" },
    { id: 101, name: "IR" },
  ]; //工单类型
  @Provide() private loanTypeData: any = [
    { id: 1, name: "首贷" },
    { id: 2, name: "复贷" },
    { id: 3, name: "首复贷" },
  ]; //贷款类型
  @Provide() private idVerifyData: any = [
    { id: 1, name: "实名审核" },
    { id: 2, name: "非实名审核" },
    { id: 0, name: "全部" },
  ]; //实名审核
  @Provide() private displayListData: any = [
    { id: 2, name: "随机展示" },
    { id: 3, name: "固定展示" },
  ]; //展示类型
  @Provide() private questionList: any = []; // 展示问题
  @Provide() private associatedItems: any = "";
  @Provide() private defKeys: any = []; // 默认选中选中节点Id值的数组
  @Provide() private defaultProps: any = {
    children: "kidsList",
    label: "name",
    id: "verifyinfoid",
  };
  @Provide() private token: string | null = "";
  @Provide() private isSaved: any = false;
  @Provide() private isWarning: any = false;
  @Provide() private WarningMsg: any = "";
  @Provide() private msg: any = this.$message;
  @Provide() private newQuestion: any = {
    id: "",
    qptype: "",
    questionsnum: "", //问题数量
    displaynum: "", //展示数量
    display: "", //展示leixing
    itemid: "", //工单类型
    questionlists: [], //问题IDs
    status: "",
    opuid: "",
    utime: "",
    floatinfo: "",
    opname: "", //操作人
    loantype: "", //借款类型
    idverify: "", //实名审核
    appname: ""
  };
  private created() {
    this.token = localStorage.getItem("token");
    Object.assign(this.newQuestion, this.result);
    if (this.result.qptype) {
      this.getQuestion(this.result.qptype);
    }

    if (this.result.questions) {
      this.newQuestion.questionlists = this.result.questions.split(",");
    }
    this.newQuestion.appname = this.result.appname?.split(',')
  }

  private hideMsk() {
    this.hideContainer();
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  // 问题列表
  private async getQuestion(data: any) {
    this.newQuestion.questionlists = [];
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      QpType: data ? data : this.newQuestion.qptype,
      Value: this.newQuestion.value,
    };
    const { getListQuestionReq, getListQuestionRequest }: any = await import(
      "@/request/questionConfiguration"
    );
    let res = await getListQuestionRequest.handleHttp(
      getListQuestionReq(_arg),
      this
    );
    if (res && res.right) {
      this.questionList = res.listList;
      let valuemes = "";
      this.questionList.forEach((item: any) => {
        valuemes =
          item.value.length > 12
            ? item.value.substring(0, 12) + "..."
            : item.value;
        this.$set(item, "valuemes", valuemes);
      });
    }
  }

  private async submitForm() {
    let that = this;
    if (that.saveRiskReportJudgement()) {
      let res = await that.saveQuestion("check");
      if (res == false) {
        // setTimeout(() => {
        //如果保存的时候出现告警，让用户选择是否继续保存
        if (this.isWarning == true && this.WarningMsg.code == "100103") {
          this.$confirm(this.WarningMsg.errmsg, "tips", {
            confirmButtonText: this.$tc("v0707.Yes"),
            cancelButtonText: this.$tc("v0707.No"),
            type: "warning",
          })
            .then(() => {
              this.saveQuestion("");
            })
            .catch(() => {
            });
          this.isSaved = false;
        }
        // }, 1000);
      }
    } else {
      this.$message({
        type: "error",
        message: "带*号不能为空",
      });
      return false;
    }
  }
  // 保存调取接口
  private async saveQuestion(action: any) {
    this.isSaved = true;
    let status = "";
    switch (this.newQuestion.status) {
      case 0:
        status = "2";
        break;
      case 1:
        status = "1";
        break;
      case 2:
        status = "2";
        break;
      case 3:
        status = "2";
        break;
    }
    let _arg: any = {
      id: this.newQuestion.id,
      appname: this.newQuestion.appname.toString(),
      qptype: this.newQuestion.qptype,
      questionsnum: this.newQuestion.questionsnum, //问题数量
      displaynum: this.newQuestion.displaynum, //展示数量
      display: +this.newQuestion.display, //展示数量
      itemid: this.newQuestion.itemid, //工单类型
      questions: this.newQuestion.questionlists.join(","), //问题IDs
      status: +this.newQuestion.status,
      opuid: +this.newQuestion.opuid,
      utime: +this.newQuestion.utime,
      floatinfo: this.newQuestion.floatinfo,
      opname: this.newQuestion.opname, //操作人
      loantype: this.newQuestion.loantype, //贷款类型
      idverify: this.newQuestion.idverify, //实名审核
    };
    const {
      getSaveQuestionDisplayReq,
      getSaveQuestionDisplayRequest,
      getSaveQuestionDisplayCheckRequest,
    }: any = await import("@/request/questionConfiguration");

    //------------------------------------------------
    if (action == "check") {
      let res = await getSaveQuestionDisplayCheckRequest.handleHttp(
        getSaveQuestionDisplayReq(_arg),
        this
      );

      if (res && res.code != 0) {
        this.isWarning = true;
        this.WarningMsg = res;
        this.isSaved = false;
        return false;
      }
    }

    let res = await getSaveQuestionDisplayRequest.handleHttp(
      getSaveQuestionDisplayReq(_arg),
      this
    );
    if (res && res.right) {
      this.isSaved = false;
      this.msg({
        type: "success",
        message: "提交成功",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    } else {
      this.isSaved = false;
    }
  }
  private saveRiskReportJudgement() {
    if (
      this.newQuestion.qptype != "" &&
      this.newQuestion.itemid != "" &&
      ((this.newQuestion.display == 3 &&
        this.newQuestion.questionlists.length > 0) ||
        (this.newQuestion.display == 2 && this.newQuestion.displaynum > 0))
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  // lee cancel操作
  private resetForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.closeAddDialog(false);
  }
  // lee 关闭弹窗
  private closeAddDialog(bool: boolean) {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  //返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }
}
